import React from "react";
import "./paperworkSectionCSS.scss";

import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import Acordion from "componets/molecules/acordion/acordion";
import Text from "componets/atoms/text/text";
/*
data debe seguir esta estructura:
{mdIntroduction: "",
 acordions: 
 [{title: "Un título 1", mdDescription: "una descripción del acordeón"}]
 .
 .
 .
}
 */
const PaperworkSection = ({ data, className }) => {
  return (
    <div className={className}>
      {data && data.mdIntroduction && data.mdDescription && data.acordions ? (
        <>
          <Text type={"h"} fontWeight={"bold"} textSize={4}>
            {data.mdIntroduction}
          </Text>
          <ReactMarkdown className={"p-work-section__description"}>
            {data.mdDescription}
          </ReactMarkdown>
          {data.acordions.map((value, index) => (
            <Acordion key={index} id={index} data={value}></Acordion>
          ))}

          <ReactMarkdown className={"p-work-section__description"}>
            {data.mdFooter}
          </ReactMarkdown>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default PaperworkSection;
